<div class="flex-direction-column gap-5 container-card center-center cursor-pointer" [ngClass]="{'card-selecionado' : selecionado}">
  @if (img) {
    <img [src]="img" alt="" [style]="widthImg ? 'width: ' + widthImg : ''">
  }
  <span class="font-12 weight-600">{{ texto }}</span>
</div>
